function floatLabels(container) {
  const floats = container.querySelectorAll('.float__wrapper');
  floats.forEach((element) => {
    const label = element.querySelector('label');
    const input = element.querySelector('input, textarea');
    if (label) {
      input.addEventListener('keyup', (event) => {
        if (event.target.value !== '') {
          label.classList.add('label--float');
        } else {
          label.classList.remove('label--float');
        }
      });
    }
    if (input && input.value && input.value.length) {
      label.classList.add('label--float');
    }
  });
}

function errorTabIndex(container) {
  const errata = container.querySelectorAll('.errors');
  errata.forEach((element) => {
    element.setAttribute('tabindex', '0');
    element.setAttribute('aria-live', 'assertive');
    element.setAttribute('role', 'alert');
  });
}

export {floatLabels, errorTabIndex};
